import React from 'react';
import Header from '../components/Header/Header';
import HeroSection from '../components/HeroSection/HeroSection';
import Benefits from '../components/Benefits/Benefits';
import Portfolio from '../components/Portfolio/Portfolio';

import Process from '../components/Process/Process';
import Contact from '../components/Contact/Contact';
import FloatingButtons from '../components/FloatingButtons/FloatingButtons';

const HomePage: React.FC = () => {
  return (
    <>
      <Header />
      <HeroSection />
      <Benefits />
      <Portfolio />

      <Process />
      <Contact />
      <FloatingButtons />
    </>
  );
};

export default HomePage;